<template>
  <!-- 弹窗 -->
  <Transition>
    <div class="pop-bg pass" v-show="passShow">
      <div class="pop-box">
        <!-- <p>{{ $t("注册新用户送与真Coin") }}</p> -->
		<div class="imgBox">
			<img src="../../assets/images/registerTipImg.png" class="pcImg" alt="" />
			<img src="../../assets/images/registerTipImg-m.png" class="mImg" alt="" />
		</div>
        <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="passShow = false">
        <div class="amend binding-tel">
          <!-- <div class="code">
            {{ $t("新用户送") + number +  $t("与真Coin")}}
          </div> -->
          <div class="next" @click="router.push('/regin')">{{ $t("注册") }}</div>
        </div>
      </div>
    </div>
  </Transition>



</template>
<script setup>
import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {getRegisterAward} from "@/api/register";
import {getTenantIdByName} from "@/api/system/tenant";
import {setTenantId} from "@/utils/auth";
import {useStore} from "vuex";
const router = useRouter();
const passShow = ref(false)
const number = ref("0")
// 租户名称
const tenantName = ref("与真")
const store = useStore();

onMounted(() => {
  //设置租户
  getTenantIdByName(tenantName.value).then(res =>{
    const tenantId = res.data;
    if (tenantId && tenantId >= 0) {
      setTenantId(tenantId)
      getRegisterAward().then(res => {
        res.data.forEach(item => {
          if(item.configKey === "yuzhen_newuser_regin"){
            // 保证是第一次进入，不是从其他页面返回
            if(store.state.newUserTipShowFlag){
              passShow.value = item.value === "true"
              store.state.newUserTipShowFlag = false
            }
          }
          if(item.configKey === "yuzhne_newuser_number"){
            number.value = item.value
          }
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }).catch(err =>{
    console.log("租户获取失败")
  })
})

</script>
<style src="./newUserTip.css" scoped>
</style>
